module.exports = __webpack_public_path__ + "img/note.ce96db33.svg";